import { ActionTree } from 'vuex';
import { GenericFormState } from './types';
import { RootState } from '@/vuex/types';

export const actions: ActionTree<GenericFormState, RootState> = {
    changeGenericFormState({ commit }, genericFormState: GenericFormState) {
        commit('setCurrentStepIdx', genericFormState.currentStepIdx);
        commit('setFormStateId', genericFormState.formStateId);
        commit('setFormStateName', genericFormState.formStateName);
        commit('setCurrentFormState', genericFormState.currentFormState);
        commit('setFormFields', genericFormState.formFields);
    },
    changeEventId({ commit }, eventId: number) {
        commit('setEventId', eventId);
    },
    changeFormFlowId({ commit }, formFlowId: number) {
        commit('setFormFlowId', formFlowId);
    },
};
